var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_694_236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3V23.25C20.2501 23.5384 20.0848 23.8013 19.8249 23.9263C19.5649 24.0512 19.2564 24.016 19.0312 23.8358L12 18.2108L4.96875 23.8358C4.74361 24.016 4.43506 24.0512 4.17511 23.9263C3.91517 23.8013 3.74989 23.5384 3.75 23.25V3C3.75 1.34425 5.09425 0 6.75 0H17.25C18.9057 0 20.25 1.34425 20.25 3Z",
    fill: "#414141"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_694_236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/Bookmark.6d226b3b6455b21ae81cea4153cf9aff.svg";
export { ForwardRef as ReactComponent };